let data = [
	{
		id: 0, 
		category: 'hierarchy',
		trans: 'иерархия', 
		worlds: [
			{
				key: 0,
				title: 'О-сенсей',
				trans: 'Великий учитель',
				src: '/images/hierarchy/img-0.jpg',
				//sound: '/sounds/hierarchy/sound-0.mp3',
			},
			{
				key: 1,
				title: 'Сенсей',
				trans: 'Учитель',
				src: '/images/hierarchy/img-1.jpg',
				//sound: '/sounds/hierarchy/sound-1.mp3',
			},
			{
				key: 2,
				title: 'Учи деши',
				trans: 'Старший ученик',
				src: '/images/hierarchy/img-2.jpg',
				//sound: '/sounds/hierarchy/sound-2.mp3',
			},
			{
				key: 3,
				title: 'Сэмпай',
				trans: 'Старший ученик',
				src: '/images/hierarchy/img-3.jpg',
				//sound: '/sounds/hierarchy/sound-3.mp3',
			},
			{
				key: 4,
				title: 'Нюмонся',
				trans: 'Младший ученик',
				src: '/images/hierarchy/img-4.jpg',
				//sound: '/sounds/hierarchy/sound-4.mp3',
			},
		]
	}, 
	{
		id: 1, 
		category: 'ritual',
		trans: 'ритуал',
		worlds: [
			{
				id: 0,
				title: 'Рэй',
				trans: 'Поклон',
				src: '/images/ritual/img-0.jpg',
				sound: '/sounds/ritual/sound-0.mp3',
			},
			{
				id: 1,
				title: 'Шомен-ни-рэй',
				trans: 'Поклон шомену',
				src: '/images/ritual/img-1.jpg',
				sound: '/sounds/ritual/sound-1.mp3',
			},
			{
				id: 2,
				title: 'Сенсей-ни-рэй',
				trans: 'Поклон учителю',
				src: '/images/ritual/img-2.jpg',
				sound: '/sounds/ritual/sound-2.mp3',
			},
			{
				id: 3,
				title: 'Отагай-ни-рэй',
				trans: 'Поклон друг другу',
				src: '/images/ritual/img-3.jpg',
				sound: '/sounds/ritual/sound-3.mp3',
			},
			{
				id: 5,
				title: 'О-нэгаи-шимас',
				trans: 'Приглашаю Вас',
				src: '/images/ritual/img-5.jpg',
				sound: '/sounds/ritual/sound-5.mp3',
			},
		]
	}, 
	{
		id: 2, 
		category: 'polite',
		trans: 'слова вежливости',
		worlds: [
			{
				id: 0,
				title: 'Конничива',
				trans: 'Здравствуйте',
				src: '/images/polite/img-0.jpg',
				sound: '/sounds/polite/sound-0.mp3',
			},
			{
				id: 1,
				title: 'Аригато',
				trans: 'Спасибо',
				src: '/images/polite/img-1.jpg',
				sound: '/sounds/polite/sound-1.mp3',
			},
			{
				id: 2,
				title: 'Саёнара',
				trans: 'До свидания',
				src: '/images/polite/img-2.jpg',
				sound: '/sounds/polite/sound-2.mp3',
			},
			{
				id: 3,
				title: 'Домо аригато годзаимас',
				trans: 'Большое спасибо',
				src: '/images/polite/img-3.jpg',
				sound: '/sounds/polite/sound-3.mp3',
			},
		]
	}, 
	{
		id: 3, 
		category: 'orders',
		trans: 'команды',
		worlds: [
			{
				id: 0,
				title: 'Хай',
				trans: 'Возглас для привлечения внимания',
				src: '/images/orders/img-0.jpg',
				sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 1,
				title: 'Дозо',
				trans: 'Пожалуйста, приступайте',
				src: '/images/orders/img-1.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 2,
				title: 'Сейдза',
				trans: 'Садитесь',
				src: '/images/orders/img-2.jpg',
				sound: '/sounds/orders/sound-2.mp3',
			},
			{
				id: 3,
				title: 'Татэ',
				trans: 'Встать',
				src: '/images/orders/img-3.jpg',
				sound: '/sounds/orders/sound-3.mp3',
			},
			{
				id: 4,
				title: 'Хаджимэ',
				trans: 'Начинайте',
				src: '/images/orders/img-4.jpg',
				sound: '/sounds/orders/sound-4.mp3',
			},
			{
				id: 5,
				title: 'Матэ',
				trans: 'Остановиться',
				src: '/images/orders/img-5.jpg',
				//sound: '/sounds/orders/sound-5.mp3',
			},
			{
				id: 6,
				title: 'Ямэ',
				trans: 'Остановиться',
				src: '/images/orders/img-6.jpg',
				sound: '/sounds/orders/sound-6.mp3',
			},
			{
				id: 7,
				title: 'Маитта',
				trans: 'Сдаюсь!',
				src: '/images/orders/img-7.jpg',
				sound: '/sounds/orders/sound-7.mp3',
			},
			{
				id: 8,
				title: 'Котаи',
				trans: 'Сменить партнера',
				src: '/images/orders/img-8.jpg',
				sound: '/sounds/orders/sound-8.mp3',
			},
		]
	}, 
	{
		id: 4, 
		category: 'technique',
		trans: 'техника',
		worlds: [
			{
				id: 0,
				title: 'Нагэ',
				trans: 'Тот, кто выполняет прием',
				src: '/images/technique/img-0.jpg',
				sound: '/sounds/technique/sound-0.mp3',
			},
			{
				id: 1,
				title: 'Укэ',
				trans: 'Тот, кто нападает',
				src: '/images/technique/img-1.jpg',
				sound: '/sounds/technique/sound-1.mp3',
			},
			{
				id: 2,
				title: 'Ай-тэ',
				trans: 'Партнер ("дружеская рука")',
				src: '/images/technique/img-2.jpg',
				sound: '/sounds/technique/sound-2.mp3',
			},
		]
	}, 
	{
		id: 5, 
		category: 'dodjo',
		trans: 'додзё',
		worlds: [
			{
				id: 0,
				title: 'Додзе',
				trans: 'Место, где постигается Путь',
				src: '/images/dodjo/img-0.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 1,
				title: 'Шомэн',
				trans: 'Портрет основателя айкидо',
				src: '/images/dodjo/img-1.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 2,
				title: 'Татами',
				trans: 'Тренировочные маты',
				src: '/images/dodjo/img-2.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
		]
	}, 
	{
		id: 6, 
		category: 'score',
		trans: 'от 1 до 10',
		worlds: [
			{
				id: 0,
				title: 'Ни',
				trans: '2',
				src: '/images/score/img-0.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 1,
				title: 'Дзю',
				trans: '10',
				src: '/images/score/img-1.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 2,
				title: 'Го',
				trans: '5',
				src: '/images/score/img-2.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 3,
				title: 'Сан',
				trans: '3',
				src: '/images/score/img-3.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 4,
				title: 'Си',
				trans: '4',
				src: '/images/score/img-4.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 5,
				title: 'Ити',
				trans: '1',
				src: '/images/score/img-5.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 6,
				title: 'Року',
				trans: '6',
				src: '/images/score/img-6.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 7,
				title: 'Сити',
				trans: '7',
				src: '/images/score/img-7.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 8,
				title: 'Хати',
				trans: '8',
				src: '/images/score/img-8.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 9,
				title: 'Кю',
				trans: '9',
				src: '/images/score/img-9.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
		]
	}, 
	{
		id: 7, 
		category: 'body-parts',
		trans: 'части тела',
		worlds: [
			{
				id: 0,
				title: 'Мэн',
				trans: 'Голова',
				src: '/images/parts/img-0.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 1,
				title: 'Куби',
				trans: 'Шея',
				src: '/images/parts/img-1.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
			{
				id: 2,
				title: 'Ката',
				trans: 'Плечо',
				src: '/images/parts/img-2.jpg',
				//sound: '/sounds/orders/sound-0.mp3',
			},
		]
	}, 
];
export default data;